module.exports = __webpack_public_path__ + "img/enhance_your_experience.5a8dde26.jpg";